module.exports = __webpack_public_path__ + "img/symbol_12.8dceb94b.png";